<template>
  <div class="NotFound">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 style="text-align: center">
          <v-card height="400" color="transparent" flat>
            <div v-if="isproduct" class="display-2 mt-5">{{ getTitle }}</div>
            <div v-else class="display-1 mt-5">{{ getTitle }}</div>
            <div style="font-size: 16px" class="grey--text lighten-5 pt-2">
              {{ getText }}
            </div>
            <div class="pt-4">  
            <el-button
            v-if="isproduct"
            class="mr-2"
            tile
            @click.native="goBack()"
            title="Atgal"
          /></div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  created() {
    if (
      this.$route.params.type != 'unreviewed' &&
      this.$route.params.type != 'rejected' &&
      this.$route.params.type != 'showOnlyStatements' &&
      this.$route.params.type != 'serviceUnavailable'
    ) {
      this.$router.push({ name: 'sav404' })
    }
  },
  computed: {
    isproduct() {
      return this.$route.params.type == 'rejected' || this.$route.params.type == 'unreviewed'
    },
    getTitle() {
      switch (this.$route.params.type || null) {
        case 'rejected':
          return this.$t('Išrašo užsakymas atmestas')
        case 'unreviewed':
          return this.$t('Išrašo užsakymas apdorojamas')
        case 'showOnlyStatements':
          return this.$t('Asmuo dėl amžiaus yra apribotas matyti pasirinktą meniu punktą')
        case 'serviceUnavailable':
          return this.$t('Ši paslauga jums neteikiama')
        default:
          return ''
      }
    },
   
    getText() {
      switch (this.$route.params.type || null) {
        case 'rejected':
          return this.$t(
            'Dėl papildomos informacijos prašome keiptis į Įgaliojimų registro klientų aptarnavimo skyrių.'
          )
        case 'unreviewed':
          return this.$t(
            'Įgaliojimų registro klientų aptarnavimo skyrius gavo žinutę dėl išrašo užsakymo.'
          )
            case 'showOnlyStatements':
          return this.$t(
            'Dėl papildomos informacijos prašome keiptis į Įgaliojimų registro klientų aptarnavimo skyrių.'
          )

          
        default:
          return ''
      }
    },
  },
  methods: {
     goBack(){
      const url = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}services.do?showValidOnly=true&persist=new`
      window.location.href = url
      // window.history.back();
    },
  },
}
</script>

<style lang="scss" scoped></style>
